import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useRouteMatch, Switch, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

// import { getSingleConsultations} from "../../store/actions";
import AppointmentList from "./AppointmentList";
import AccountNotActivate from "../AccountNotActivate/AccountNotActivate";

const Appointments = ({ consultant }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const { path } = useRouteMatch();
  const loaction = useLocation();
  useEffect(() => {
    const { loading, error, data } = consultant;
    setLoading(loading);
    setError(error);
  }, [consultant]);
  const renderView = () => {
    if (loading) {
      return "Loading ...";
    }
    if (error) {
      return "Error";
    }
    if (consultant.data) {
      return (
        <motion.div className="container-fluid Appointment">
          {consultant.data && consultant.data.verifiedAt ? (
            <AnimatePresence exitBeforeEnter>
              <Switch location={loaction} key={loaction.pathname}>
                <Route exact path={`${path}`} component={AppointmentList} />
                {/* <Route path={`${path}/:child`} component={Child} /> */}
              </Switch>
            </AnimatePresence>
          ) : (
            <AccountNotActivate />
          )}
        </motion.div>
      );
    } else {
      return "";
    }
  };
  return renderView();
};
const mapStateToProps = (state) => {
  return {
    consultant: state.consultant,
  };
};
export default connect(mapStateToProps)(Appointments);
